import { callProcedure } from 'core/classes/helpers/callProcedure'
import Logger from 'core/utils/Logger'
import { IReorderDataFn } from 'partner360/widgets/assortmentTab/context/models/IReorderDataFn'

import { IAssortmentItem } from '../models/data/IAssortmentItem'

export const applyAssortmentItemsSortOrder: IReorderDataFn<IAssortmentItem> = async ({
  partnerId,
  fYear,
  programType,
  data,
}) => {
  try {
    const response = callProcedure('spJBPAssortmentApplyChangesSortOrder', {
      'p.PartnerId': partnerId,
      'p.FYear': fYear,
      'p.ProgramType': programType,
      'p.Data': data.map(({ EntryId, SortOrder, AssortmentGroupId }) => ({
        EntryId,
        SortOrder,
        AssortmentGroupId,
      })),
    })
    return response
  } catch (e) {
    Logger.log(e)
    return []
  }
}
